import React from "react";
import { constants } from "@/constants.js";
import { urlChatID } from "@/utils/url.js";

import { useQueryClient, useQuery } from "react-query";
import { EventBus } from "@/store/event-bus";
import { queryKeyChatbotSummary } from "@/pages/chatbot/sources/ChatBotSources";
import DocStatusBadge from "@/components/DocStatusBadge.jsx";
import { queryKey } from "@/store/queryKeys";
import {useTranslation} from "react-i18next";
import Loading from "@/components/Loading";
import {Icon} from "@/components/Icon.tsx";

const ListQuestions = (props: any) => {
  const queryClient = useQueryClient();
  const {t} = useTranslation();

  let { isLoading, isError, data } = useQuery(
    queryKey.chatbotSourcesQuestions(),
    async function () {
      let res = await fetch(
        `${constants.url.API_PREFIX}chatbot/${urlChatID()}/questions`,
      );
      return res.json();
    },
  );
  const invalidateCache = () => {
    queryClient.invalidateQueries(queryKey.chatbotSourcesQuestions());
    queryClient.invalidateQueries(queryKeyChatbotSummary);
  };

  const [uploadHandler, setUploadHandler] = React.useState(false);

  if (!uploadHandler) {
    setUploadHandler(true);
    let bus = EventBus.getInstance().registerSingle(
      "chatbot.sources.questions.add",
      () => {
        invalidateCache();
      },
    );
  }
  const apiDocumentDelete = (id: string) => {
    return fetch(
      `${constants.url.API_PREFIX}chatbot/${urlChatID()}/document/${id}/delete`,
    ).then(invalidateCache);
  };

  if (isLoading) return <Loading />;
  if (isError || !data) return <p>Error: Can't load files</p>;

  let charactersTotal = 0;
  return (
    <div className="mt-4">
      <div className="py-1 font-bold flex justify-between">
        <div className="w-[35%] flex items-center">
          {t("knowledge_base.qa.question")} {data.questions.length ? `(${data.questions.length})` : ``}
        </div>
        <div className="w-[35%] flex items-center">{t("knowledge_base.qa.answer")}</div>
        <div className="flex justify-center w-20">{t("knowledge_base.characters")}</div>
        <div className="flex justify-center w-20">{t("knowledge_base.actions")}</div>
      </div>
      {data.questions.map((item: any, i: number) => {
        charactersTotal += item.characters !== -1 ? item.characters : 0;
        return (
          <div
            key={i}
            className="py-3 border-b hover:bg-slate-200 flex justify-between"
          >
            <div className="w-10 px-2">
              <DocStatusBadge status={item.status} />
            </div>
            <div className="w-[35%]">
              {item.question}
            </div>
            <div className="w-[35%]">
              {item.text}
            </div>
            <div className="flex justify-center items-center w-20">
              {item.characters !== -1 ? item.characters : ""}
            </div>
            <div className="flex justify-center items-center w-20">
              <div
                className="cursor-pointer mr-2"
                title={"Edit"}
                onClick={(e) => {
                  props.onItemEdit(item);
                }}
              >
                {/*@ts-ignore*/}
                <Icon
                  icon="fluent:document-edit-16-regular"
                  className="w-6 h-6 text-gray-400 hover:text-blue"
                />
              </div>
              <div
                className="cursor-pointer"
                title={"Delete text"}
                onClick={(e) => apiDocumentDelete(item.id)}
              >
                {/*@ts-ignore*/}
                <Icon
                  icon="heroicons:archive-box-x-mark"
                  className="w-6 h-6 text-gray-400 hover:text-red-600"
                />
              </div>
            </div>
          </div>
        );
      })}
      {!!data.questions.length && (
        <div className="py-1 font-bold flex justify-between">
          <div className="w-[35%] flex items-center"></div>
          <div className="w-[35%] flex items-center"></div>
          <div className="flex justify-center w-20">
            {charactersTotal ? charactersTotal : ""}
          </div>
          <div className="flex justify-center w-20"></div>
        </div>
      )}
    </div>
  );
};

export default ListQuestions;
